import React from 'react';
import {
  $createNodeSelection,
  $createParagraphNode,
  $getNodeByKey,
  $isElementNode,
  $isRootNode,
  $setSelection,
} from 'lexical';
import Html from '../../ui/html/Html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export function HtmlNodeComponent({ nodeKey, html }) {
  const [editor] = useLexicalComposerContext();
  const [isEditing, setIsEditing] = React.useState(true);

  const updateHtml = value => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);
      node.html = value;
    });
  };

  const selectSibling = (sibling, selectEnd) => {
    if ($isElementNode(sibling)) {
      if (selectEnd) {
        sibling.selectEnd();
      } else {
        sibling.selectStart();
      }
    } else {
      const nodeSelection = $createNodeSelection();
      nodeSelection.add(sibling.getKey());
      $setSelection(nodeSelection);
    }
  };

  const escapeUp = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if (node === null) return;

      let previousSibling = node.getPreviousSibling();

      if (previousSibling === null) {
        previousSibling = $createParagraphNode();
        node.insertBefore(previousSibling);
      }

      selectSibling(previousSibling, true);
    });
  };

  const escapeDown = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if (node === null) return;

      let nextSibling = node.getNextSibling();

      if (nextSibling === null) {
        nextSibling = $createParagraphNode();
        node.insertAfter(nextSibling);
      }

      selectSibling(nextSibling, false);
    });
  };

  const removeNode = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);

      if (node === null) return;

      if ($isRootNode(node)) {
        node.getFirstChild().remove();
        return;
      }

      const previousSibling = node.getPreviousSibling();
      const nextSibling = node.getNextSibling();

      node.remove();

      // place the cursor next to where the block was; without an explicit
      // selection the editor blur handler resets it to the document start
      if (previousSibling !== null) {
        selectSibling(previousSibling, true);
      } else if (nextSibling !== null) {
        selectSibling(nextSibling, false);
      }
    });
  };

  return (
    <Html
      html={html}
      isEditing={isEditing}
      nodeKey={nodeKey}
      updateHtml={updateHtml}
      escapeUp={escapeUp}
      escapeDown={escapeDown}
      removeNode={removeNode}
    />
  );
}
